<template>
  <div class="print-signature-area" style="font-size: 15px;">
    <slot v-if="$slots.title" name="title"></slot>
    <div v-else class="title">{{ title }}：</div>
    <div><b v-if="leaveData[status]===0||leaveData[status]" style="font-weight:600;">{{ getReviewName(leaveData[status]) }}</b></div>
    <div class="flex-1 oh" style="min-height: 60px;font-size: 15px;">{{ leaveData[opinion] }}</div>
    <div v-if="leaveData[userName]"  class="mt-1">
      <div >签字：{{ leaveData[userName] }}
        <span class="ml-1" style="font-size: 15px;"> {{ leaveData[signTime] | formatDate('YYYY 年 MM 月 DD 日') }}
      </span>
      </div>
    </div>
    <div v-else class="mt-1">
      <div>签字：
      <span class="ml-1"
            style="font-size: 15px;"><i style="padding-left: 4em;"></i>年<i style="padding-left: 2em;"></i>月<i style="padding-left: 2em;"></i>日</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'printSignatureArea',
  props: {
    title: String,
    opinion: String,
    status: String,
    userName: String,
    signTime: String,
    leaveData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {}
  },
  methods: {
    getReviewName(status) {
      if (status === 0 || status === '0') {
        return '审批不通过'
      } else if (status === 1 || status === '1') {
        return '审批通过'
      } else {
        return '待审批'
      }
    }
  }
}
</script>

<style lang="scss">
.print-signature-area {
  @include flex-column;
  justify-content: flex-start;
  height: 100%;
  .title{
    white-space: nowrap;
  }
}
</style>
